define((require) => {
    "use strict";

    var ViewController   = require("editor/util/ViewController");

    /**
     * A view controller for the <tt>ActionsView</tt>. For now, it's sole purpose is to handle legacy
     * 'actions', i.e. <tt>AbstractWidgetModel#actions</tt>, making sure they are replaced/updated/removed
     * onto the 'action' property.
     *
     * @see ActionsView
     * @class ActionsViewController
     */
    return ViewController.extend({

        onInitialize: function() {
            var legacyActions = this.model.get("actions");
            // If the current widget model contains any legacy actions
            if (legacyActions.length > 0) {
                // Grab the first action and store it as the primary widget action (excluding the id - {duplicate: true})
                this.model.set("action", legacyActions.at(0).clone({duplicate: true}));
                // Reset/empty the legacy action collection
                legacyActions.reset();
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/ActionsViewController.js